import { Country } from '../country';

export type TierType = 'shipping' | 'discount';

export interface Tier {
  threshold: number;
  discountPercent: number;
  type: TierType;
}

export interface UserTypeTiers {
  registeredFirstOrder: Tier[];
  registeredReturning: Tier[];
  guest: Tier[];
}

export type BMSMTiersConfig = Record<Country, UserTypeTiers>;

export type IconVariant = 'check' | 'dot';

export interface MilestoneDisplayConfig {
  /** Whether this benefit is currently active/applied (Guest can only have one active) */
  active: boolean;
  /** Icon type: 'check' for active or not-achieved, 'dot' for achieved-but-not-active */
  iconVariant: IconVariant;
}
